import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import List from '../../../components/List'
import WidthContainer from '../../../components/WidthContainer'
import StarsContainer from '../../../components/Stars'


const RootContainer = styled(WidthContainer)`
	position: relative;
`


const InnerContainer = styled.div`
	display: flex;
	position: relative;
	
	margin: 1rem -2rem;
	
	> * {
		margin 2rem;
	}
	
	@media only screen and (max-width: 1000px) {
		flex-direction: column-reverse;
		align-items: center;
	} 
`

const Column = styled.div`
	flex: 1;
	max-width: 30rem;
`

const Title = styled.h2`
	font-size: ${props => props.theme.fontSizes.big20};
	margin-bottom: 2.3rem;
`

const BulletsStyled = styled(List)`
`

const Topic = styled.div`
	max-width: 28rem;
	font-size: ${props => props.theme.fontSizes.big40};
	font-weight: ${props => props.theme.fontWeights.bold};
	line-height: 1.2;
	width: 100%;
	
	@media only screen and (max-width: 1000px) {
		font-size: ${props => props.theme.fontSizes.big20};
	}
`

const WhyTopicsSection = ({className, data}) => <RootContainer className={className}>
	<StarsContainer/>
	<InnerContainer>
		<Column>
			<Title>{data.why.title}</Title>
			<BulletsStyled items={data.why.bullets.map(one => one.textMd)}/>
		</Column>
		<Column>
			<Title>{data.topics.title}</Title>
			{data.topics.list.map(one => <Topic key={one}>{one}</Topic>)}
		</Column>
	</InnerContainer>
</RootContainer>

WhyTopicsSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		why: PropTypes.shape({
			title: PropTypes.string.isRequired,
			bullets: PropTypes.arrayOf({
				textMd: PropTypes.string.isRequired,
			}).isRequired,
		}).isRequired,
		topics: PropTypes.shape({
			title: PropTypes.string.isRequired,
			list: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
		}).isRequired,
	}).isRequired,
}

WhyTopicsSection.defaultProps = {
	className: '',
}

export default WhyTopicsSection
